/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Announcement } from '../../models/announcement';

export interface DeleteAnnouncement$Params {
  ref: string;
}

export function deleteAnnouncement(http: HttpClient, rootUrl: string, params: DeleteAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<Announcement>> {
  const rb = new RequestBuilder(rootUrl, deleteAnnouncement.PATH, 'delete');
  if (params) {
    rb.path('ref', params.ref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Announcement>;
    })
  );
}

deleteAnnouncement.PATH = '/v1/api/admin-ui/announcement/delete/{ref}';
